import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ModelChartRealPredictedKpi } from "../types";

export const useModelChartRealPredictedKpi = (model_id: number) => {
  return useQuery({
    queryKey: ["model", "charts", "kpi", model_id],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/charts/kpi`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelChartRealPredictedKpi;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
